import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import Footer from './Footer';

export const Layout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0F172A] texture-noise pb-8 lg:pb-6">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {/* Contenu principal - pas de marge sur mobile, marge sur desktop */}
      <div className="lg:ml-64">
        <Header 
          title={title} 
          onMenuClick={() => setSidebarOpen(true)} 
        />
        <main className="p-4 lg:p-6 relative z-10">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};
